import React, { useEffect, useState } from "react";
import Sidebar from "../../context/SideBar";
import axios from "axios";

const SidebarPage = ({ children }) => {
  const [user, setUser] = useState({ name: "", role: "" });
  
  useEffect(() => {
    const validateUser = async () => {
      const token = localStorage.getItem("authToken");
      
      try {
        const response = await axios.post("http://esnakademi.com/api/auth/validate", 
          { token: token }
        );
        

        
        // Response HTML ve JSON karışımı olduğu için JSON kısmını çıkaralım
   
      
        
        // JWT token'ı manuel olarak decode et
        if (token) {
          try {
            // JWT'nin payload kısmını al ve decode et
            const payload = token.split('.')[1];
            const decodedPayload = JSON.parse(atob(payload));
        
            
            // Kullanıcı bilgilerini token'dan çıkar
            setUser({
              ...user,
              name: decodedPayload.data?.username || user.name,
              role: decodedPayload.data?.role || ""
            });
          } catch (e) {
            console.error("JWT decode error:", e);
          }
        }
        
      } catch (error) {
        console.error("Token doğrulama hatası:", error);
      }
    };
    
    validateUser();
  }, []);

  return (
    <>
      <Sidebar user={user} />
      <div className="w-full lg:ml-64 lg:w-[calc(100vw-16rem)] p-2 sm:p-4 transition-all duration-300 min-h-screen overflow-x-hidden box-border">{children}</div>
    </>
  );
};

export default SidebarPage;